function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P4Header = function P4Header(_ref) {
  var page = _ref.page;
  var thisPage = 6;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $('.p4-extract').addClass('p4-extract__active');
      }, 1500), setTimeout(function () {
        $('.p4-extract-m').addClass('p4-extract-m__active');
      }, 1500), setTimeout(function () {
        $('.p4-arrow1').addClass('p4-arrow1__active');
      }, 2500), setTimeout(function () {
        $('.p4-use').addClass('p4-use__active');
      }, 2500), setTimeout(function () {
        $('.p4-use-m').addClass('p4-use-m__active');
      }, 2500), setTimeout(function () {
        $('.p4-arrow2').addClass('p4-arrow2__active');
      }, 3500), setTimeout(function () {
        $('.p4-dispose').addClass('p4-dispose__active');
      }, 3500), setTimeout(function () {
        $('.p4-dispose-m').addClass('p4-dispose-m__active');
      }, 3500)]);
    } else {
      $('.p4-extract').removeClass('p4-extract__active');
      $('.p4-extract-m').removeClass('p4-extract-m__active');
      $('.p4-use').removeClass('p4-use__active');
      $('.p4-use-m').removeClass('p4-use-m__active');
      $('.p4-dispose').removeClass('p4-dispose__active');
      $('.p4-dispose-m').removeClass('p4-dispose-m__active');
      $('.p4-arrow1').removeClass('p4-arrow1__active');
      $('.p4-arrow2').removeClass('p4-arrow2__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p4-header"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/extract-header@3x.png",
    className: "p4-extract"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/arrows-big-copy@3x.png",
    className: "p4-arrow1"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/use-header@3x.png",
    className: "p4-use"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/arrows-big-copy@3x.png",
    className: "p4-arrow2"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/dispose-header@3x.png",
    className: "p4-dispose"
  })), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/extract-header@3x.png",
    className: "p4-extract-m"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/use-header@3x.png",
    className: "p4-use-m"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p4/dispose-header@3x.png",
    className: "p4-dispose-m"
  }));
};
export default P4Header;